import type ReadingPaneInfoBarId from './ReadingPaneInfoBarId';

export default function initializeInfoBarIdsForItem(): ReadingPaneInfoBarId[] {
    const infoBarItems: ReadingPaneInfoBarId[] = [
        'unsubscribeInfoBar',
        'safetyBar',
        'infoImportance',
        'infoSensitivity',
        'infoFlagStatus',
        'irmInfoBar',
        'infoMessageSubmitted',
        'agendaMailFeedback',
        'unauthenticatedSender',
        'infoDelegate',
        'infoMeetingAttendeeDoNotForward',
        'infoSMIME',
        'infoSmimeDecodeError',
        'infoSmimeSigned',
        'addinDecryptionTimedOut',
        'addinDecryptionBlocked',
        'addinDecryptionFailed',
        'addinDecryptionTakingLonger',
        'addinDecryptionSuccess',
        'infoItemPartLoadFailure',
        'encryptedMessageInfo',
        'infoLastUserAction',
        'infoReadReceiptRequested',
        'translateInfoBar',
        'infoResend',
        'infoPolicyTag',
        'infoMessageApprovalAndVoting',
        'infoMessageClassification',
        'infoCLPLabel',
        'infoRevocation',
        'externalMessage',
        'latestRecallAttempt',
        'scheduleSendMessage',
        'meetingMessageInfo',
        'refreshScreenCapture',
    ];
    return infoBarItems;
}
